import { get } from '@/api/base'
import { ResponseError } from '@/classes/ResponseError'

export const CHANGELOG_URL = 'changelog'
export const CHANGELOG_OBJECT_URL = `${CHANGELOG_URL}/object`

export const EChangelogType = {
  pto: 'App\\Models\\Pto\\PtoObject',
  contract: 'App\\Models\\Treaty\\Treaty'
}

// TODO получение журнала по типам
export const ChangelogApi = {
  getAll: async (params) => {
    try {
      return await get(CHANGELOG_URL, params)
    } catch (e) {
      throw new ResponseError(e, 'Не удалось загрузить журнал изменений')
    }
  },

  getObjects: async (params) => {
    try {
      return await get(CHANGELOG_OBJECT_URL, params)
    } catch (e) {
      throw new ResponseError(e, 'Не удалось загрузить список объектов журнала изменений')
    }
  }
}
